<template>
    <div>
        <div v-if="feedback_id === null" class="uk-grid-small"
             uk-grid>

            <div class="uk-width-1-1">
                <label class="uk-form-label">Ваше имя</label>
                <div class="uk-form-controls">
                    <input :class="{' uk-form-danger': errors.has('customer')}"
                           v-validate="{required: true, alpha: true }" name="customer"
                           placeholder="Ваше имя" v-model="formData.ShopFeedback.customer" class="uk-input"
                           type="text">
                </div>
            </div>

            <div class="uk-width-1-1 uk-width-1-2@s">
                <label class="uk-form-label">Телефон</label>
                <div class="uk-form-controls">
                    <input placeholder="Ваш телефон*" :class="{' uk-form-danger': errors.has('phone')}"
                           v-validate="{ required: true, regex: /^([0-9\s\-\+\(\)]{7,})$/ }"
                           v-model="formData.ShopFeedback.phone" name="phone" class="uk-input" type="tel">
                </div>
            </div>
            <div class="uk-width-1-1 uk-width-1-2@s">
                <label class="uk-form-label">Удобное время для звонка</label>
                <div class="uk-form-controls">
                    <input placeholder="С 10 до 18" name="time" v-model="formData.ShopFeedback.time"
                           class="uk-input" type="text">
                </div>
            </div>

            <div class="uk-width-1-1">
                <label class="uk-form-label">Email</label>
                <div class="uk-form-controls">
                    <input placeholder="Ваш e-mail" :class="{' uk-form-danger': errors.has('email')}"
                           v-validate="{ required: true, email: true }" name="email"
                           v-model="formData.ShopFeedback.email" class="uk-input" type="email">
                </div>
            </div>


            <div class="uk-width-1-1">
                <label class="uk-form-label">Примечание</label>
                <div class="uk-form-controls">
                    <textarea v-model="formData.ShopFeedback.message" class="uk-textarea" rows="3"></textarea>
                </div>
            </div>


            <div class="uk-width-1-1 uk-text-meta">
                <p>
                    График работы: пн–пт с 9:00 до 18:00<br>
                    Если вы оставили запрос в нерабочее время, он будет обработан в начале следующего рабочего
                    дня.
                </p>
            </div>

            <div class="uk-width-1-1 uk-text-center">
                <button @click="send" class="uk-button uk-button-primary"
                        type="submit">Отправить
                </button>
            </div>

        </div>
        <div v-else class="uk-grid-small"
             uk-grid>
            <div class="uk-width-1-1 uk-text">
                <p>
                    Заявка успешно отправлена.
                </p>
            </div>
            <div class="uk-width-1-1 uk-text-meta">
                <p>
                    График работы: пн–пт с 9:00 до 18:00<br>
                    Если вы оставили запрос в нерабочее время, он будет обработан в начале следующего рабочего
                    дня.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ShopFeedback",
        data() {
            return {
                loading: false,
                feedback_id: null,
                formData: {
                    ShopFeedback: {
                        customer: '',
                        phone: '',
                        email: '',
                        time: '',
                        message: '',
                    }
                }
            }
        },
        methods: {
            send() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading = true;
                        this.$http.post('/feedback/send', this.formData).then(response => {
                            this.feedback_id = response.body.data.id;
                            this.loading = false;
                        }, response => {
                        })
                    }

                });

            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ShopFeedback.vue?d95204de